module.exports = __webpack_public_path__ + "./fonts/WhiteThumbnail.052c02f2e4d6d4a471f0558ec0017362.svg";